import { notification } from 'antd';

import { track } from '../../../../tracking';

export const focusCard = (
    id: string,
    options: boolean | ScrollIntoViewOptions = { behavior: 'smooth' },
): void => {
    const card = document.getElementById(id);

    if (!card) {
        track('MAGIC_BOX_FOCUS_CARD', { key: id, cardFound: false.toString() });
        notification.error({
            message: 'Enable section from the pad config',
            duration: 5,
        });
        return;
    }

    track('MAGIC_BOX_FOCUS_CARD', { key: id, cardFound: true.toString() });

    card.scrollIntoView(options);
};
